// src/components/sample-data-banner.tsx
import { useUser } from "@clerk/clerk-react";
import { AlertCircle } from "lucide-react";
import { useState, useEffect } from "react";

// Hook to safely use campaign data context
function useCampaignDataSafely() {
  try {
    // Dynamically import to avoid errors when context doesn't exist
    const { useCampaignData } = require("@/contexts/campaign-data");
    return useCampaignData();
  } catch {
    // Return safe defaults when CampaignDataProvider is not available
    return {
      useSampleData: false,
    };
  }
}

export const SampleDataBanner = () => {
  const campaignData = useCampaignDataSafely();
  const { useSampleData } = campaignData;
  const { isSignedIn, user } = useUser();
  const [isPromoBannerVisible, setIsPromoBannerVisible] = useState(false);

  useEffect(() => {
    // Check if promo banner is visible (not dismissed)
    const bannerKey = user?.id
      ? `promo-banner-dismissed-${user.id}`
      : "promo-banner-dismissed-anon";
    const isDismissed = localStorage.getItem(bannerKey) === "true";
    setIsPromoBannerVisible(!isDismissed);
  }, [user]);

  // Don't show if not using sample data or if promo banner is visible
  if (!useSampleData || isPromoBannerVisible) return null;

  return (
    <div className="bg-orange-400/95 dark:bg-orange-600/95 border-b-2 border-orange-500 dark:border-orange-500">
      <div className="container flex items-center gap-4 px-6 py-2 text-lg font-medium text-orange-950 dark:text-white">
        <AlertCircle className="h-6 w-6" />
        {isSignedIn ? (
          <p>
            Currently viewing sample data - switch accounts to see your data
          </p>
        ) : (
          <p>
            Currently viewing sample data - Sign Up to see your own data (or
            Sign In if you already have an account)
          </p>
        )}
      </div>
    </div>
  );
};
